/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    WAITING_FOR_PAYMENT: 'waiting',
    PAID: 'paid',
    NOT_PAID: 'notPaid', // Not paid within the required period = overdue
    VOID: 'void', // Not paid and cancelled by customer before reaching the required period for payment
    REFUND: 'refund', // Paid but cancelled by customer within the period for withdrawal from the purchase agreement
};
